import React from "react";
import { useLocation } from "react-router-dom";
import { Box, Divider, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import Morning from "../../img/CourseMorning.svg";
import Night from "../../img/CourseNight.svg";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme, isMobile) => ({
  container: {
    width: { xs: "85%", md: "115%", lg: "115%", xl: "115%" },
    p: "32px 0px",
    marginTop: "48px",
    borderRadius: "53px",
    background: theme.palette.blue.main,
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    justifyContent: isMobile ? "center" : "space-around",
    alignItems: "center",
    mx: isMobile ? "auto" : "0px",
  },
  modality: {
    background: theme.palette.white.main,
    color: theme.palette.red.main,
    fontFamily: theme.typography.montserrat.bold,
    fontSize: "24px",
    width: isMobile ? "70%" : "fit-content",
    height: isMobile ? "68px" : "46px",
    padding: "0 15px",
    borderRadius: "34px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    mr: isMobile ? "0" : "32px",
    whiteSpace: "nowrap",
  },
  divider: {
    width: "60vw",
    margin: "15.5px",
    background: theme.palette.white.main,
  },
  typography: {
    title: {
      ml: isMobile ? "0" : "32px",
      color: theme.palette.white.main,
      fontFamily: theme.typography.montserrat.regular,
      fontSize: isMobile ? "24px" : { xl: "32px", lg: "26px", md: "26px" },
      width: isMobile ? "230px" : "fit-content",
    },
    modality: {
      color: theme.palette.red.main,
      fontFamily: theme.typography.montserrat.regular,
      fontSize: isMobile ? "16px" : { xl: "24px", lg: "19px", md: "19px" },
      textAlign: "left",
      margin: isMobile ? "auto" : 0,
      width: "fit-content",
    },
  },
});

const ModalityCard = ({ data }) => {
  const isMobile = useMediaQuery("(max-width:920px)");

  const theme = useTheme();
  const classes = useStyles(theme, isMobile);

  const datesHelper = (date) => {
    const timeZoneOffset = new Date(date).getTimezoneOffset();
    const dateToMilisec = new Date(date).getTime();
    const finalDate = new Date(dateToMilisec + timeZoneOffset * 60000);

    let formattedDate = finalDate
      .toLocaleDateString("es-ES", {
        dateStyle: "short",
      })
      .split("/");

    formattedDate = `${formattedDate[0]}/${formattedDate[1]}`;

    return formattedDate;
  };

  const location = useLocation();

  const formatTime = (time) => {
    const strandarizedTime = time;
    return strandarizedTime.substring(0, time.length - 3);
  };

  const { title, online, async, modality, shift } = useTranslation(
    location.pathname,
    "ModalityCard"
  );

  return location.search.includes("atr") ? (
    <Box sx={classes.container}>
      <Typography sx={classes.typography.title}>
        <b>{title}</b>
      </Typography>
      {isMobile ? <Divider sx={classes.divider} /> : <></>}
      <Box sx={classes.modality}>
        {isMobile ? (
          <>
            <Box>
              <Typography sx={classes.typography.modality}>
                <b>{online}</b>
              </Typography>
              <Typography sx={classes.typography.modality}>
                <b>{async}</b>
              </Typography>
            </Box>
          </>
        ) : (
          <>
            <Typography sx={classes.typography.modality}>
              <b>{modality}</b>
            </Typography>
          </>
        )}
      </Box>
    </Box>
  ) : (
    <Box sx={classes.container}>
      {isMobile ? (
        <>
          <Typography sx={classes.typography.title}>
            <b>
              {data.month.toUpperCase()}{" "}
              {new Date(data.startDate).getFullYear()}
            </b>
          </Typography>
          <Typography sx={classes.typography.title}>
            {datesHelper(data.startDate)} al {datesHelper(data.endDate)}
          </Typography>
        </>
      ) : (
        <Typography sx={classes.typography.title}>
          <b>
            {data.month.toUpperCase()} {new Date(data.startDate).getFullYear()}{" "}
            |
          </b>{" "}
          {datesHelper(data.startDate)} al {datesHelper(data.endDate)}
        </Typography>
      )}
      {isMobile ? <Divider sx={classes.divider} /> : <></>}
      <Box sx={classes.modality}>
        {isMobile ? (
          <>
            <img
              src={data.shift === "tarde" ? Night : Morning}
              alt=""
              style={{ height: "20px", marginRight: "10px" }}
            />
            <Box>
              <Typography sx={classes.typography.modality}>
                <b>TURNO {data.shift.toUpperCase()}</b>
              </Typography>
              <Typography sx={classes.typography.modality}>
                {formatTime(data.startHour)} a {formatTime(data.endHour)}hs
              </Typography>
            </Box>
          </>
        ) : (
          <>
            <img
              src={data.shift === "tarde" ? Night : Morning}
              alt=""
              style={{ height: "20px", marginRight: "10px" }}
            />
            <Typography sx={classes.typography.modality}>
              {shift} <b>{data.shift.toUpperCase()} |</b>{" "}
              {formatTime(data.startHour)} a {formatTime(data.endHour)}hs
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );
};

export default ModalityCard;
